<ng-container *ngIf="(canAdd() | async)">
  <button ngbDropdownItem [routerLink]="['/submit']" [queryParams] = "getCvProjectCollectionId() | async">
    {{'context-menu.actions.add-cv-project.btn' | translate}}
  </button>
</ng-container>